import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { getUser } from '../../../reducers/userReducer';
import { AuthenticatedUser } from '../../../shared/types';
import { useFeatureFlagWithStatus } from '../../../shared/featureFlags/useFeatureFlagWithStatus';
import { FeatureFlagKeys } from '../../../shared/featureFlags/featureFlagKeys';
import CustomerBookingCalendarMobile from './v2/booking/view/CustomerBookingCalendarMobile';
import CustomerRebookingCalendarMobile from './v2/rebooking/view/CustomerRebookingCalendarMobile';
import SE360PhotographerBooking from './SE360PhotographerBooking';
import { CustomerBookingMobileSkeleton } from "./v2/shared/view/CustomerBookingMobileSkeleton";

type CustomerPhotographerBookingDelegateProps = {
    user: AuthenticatedUser;
} & RouteComponentProps;

function CustomerPhotographerBookingDelegate({
    user,
    location
}: CustomerPhotographerBookingDelegateProps) {
    let theme = useTheme();
    let isSmallerScreen = useMediaQuery(theme.breakpoints.down('sm'));

    let { value: showMobileBooking, isLoading } = useFeatureFlagWithStatus(
        FeatureFlagKeys.CustomerBookingCalendarV2,
        false
    );

    if (isLoading) {
        return <CustomerBookingMobileSkeleton />
    }

    if (isSmallerScreen && showMobileBooking) {
        const params = new URLSearchParams(location.search);

        if (params.has('orderId')) {
            let orderId = Number(params.get('orderId'));
            let redirectTo = params.get('redirectTo');
            return (
                <CustomerRebookingCalendarMobile
                    user={user}
                    orderId={orderId}
                    redirectTo={redirectTo}
                />
            );
        }

        return <CustomerBookingCalendarMobile user={user} />;
    }

    return <SE360PhotographerBooking />;
}

let mapStateToProps = (state: any): { user: AuthenticatedUser } => {
    let user = getUser(state);
    return { user };
};

export default compose(connect(mapStateToProps), withRouter)(CustomerPhotographerBookingDelegate);
